import { Service } from "typedi";
import { Repository } from "./repository";
import { OnboardingProgress } from "./models/onboarding-progress.model";

@Service()
export class OnbaordingRepository extends Repository<OnboardingProgress> {
    clazz = undefined
    key = "onboarding"
}
